module.exports = __webpack_public_path__ + "static/media/foodshot17.c408a022.JPG";